export default __webpack_public_path__ + "6ce106f6979c7680c2834e6bf0066080.svg";